import { trackCustomEvent } from '../../analytics';

export const featuredVendorCardRenderedEvent = ({ advertisement }) => {
  trackCustomEvent('Featured Vendor Card Viewed', {
    vendor_id: advertisement.vendor_id,
    vendor_name: advertisement.vendor_name,
    advertisement_id: advertisement.id,
    dispensary_name: advertisement.dispensary_name || '',
  });
};

export const featuredVendorCardClickEvent = ({ advertisement }) => {
  trackCustomEvent('Featured Vendor Card Clicked', {
    vendor_id: advertisement.vendor_id,
    vendor_name: advertisement.vendor_name,
    advertisement_id: advertisement.id,
    dispensary_name: advertisement.dispensary_name || '',
  });
};

export const featuredVendorAllCardClickEvent = () => {
  trackCustomEvent('Featured Vendors All Clicked');
};

export const featuredBrandCardRenderedEvent = ({ brandAdvertisement }) => {
  trackCustomEvent('Featured Brand Card Viewed', {
    brand_id: brandAdvertisement.brand_id,
    brand_name: brandAdvertisement.name,
    advertisement_id: brandAdvertisement.id,
    dispensary_name: brandAdvertisement.dispensary_name || '',
  });
};

export const featuredBrandCardClickEvent = ({ brandAdvertisement }) => {
  trackCustomEvent('Featured Brand Card Clicked', {
    brand_id: brandAdvertisement.brand_id,
    brand_name: brandAdvertisement.name,
    advertisement_id: brandAdvertisement.id,
    dispensary_name: brandAdvertisement.dispensary_name || '',
  });
};

export const featuredVendorFavoriteToggleEvent = ({
  toggledValue,
  advertisement,
}) => {
  trackCustomEvent('Vendor Favorite Toggled', {
    favorite_toggled_value: toggledValue,
    vendor_id: advertisement.id,
    vendor_name: advertisement.name,
    advertisement_id: advertisement.id,
    dispensary_name: advertisement.dispensary_name || '',
  });
};

export const sponsoredAdViewEvent = ({ sponsoredAd }) => {
  trackCustomEvent('Sponsored Ad Viewed', {
    advertisement_id: sponsoredAd.id || '',
    sponsored_ad_id: sponsoredAd.sponsorship_id || '',
    sponsored_ad_name: sponsoredAd.name || '',
    sponsored_ad_target: sponsoredAd.app_target || sponsoredAd.target_url || '',
    vendor_id: sponsoredAd.vendor_id || '',
    vendor_name: sponsoredAd.vendor_name || '',
    dispensary_name: sponsoredAd.dispensary_name || '',
  });
};

export const sponsoredAdClickEvent = ({ sponsoredAd }) => {
  trackCustomEvent('Sponsored Ad Clicked', {
    advertisement_id: sponsoredAd.id || '',
    sponsored_ad_id: sponsoredAd.sponsorship_id || '',
    sponsored_ad_name: sponsoredAd.name || '',
    sponsored_ad_target: sponsoredAd.app_target || sponsoredAd.target_url || '',
    vendor_id: sponsoredAd.vendor_id || '',
    vendor_name: sponsoredAd.vendor_name || '',
    dispensary_name: sponsoredAd.dispensary_name || '',
  });
};

export const exploreAllSellersCardClickEvent = () => {
  trackCustomEvent('Explore All Sellers Clicked');
};

export const shopFlowerCardClickEvent = () => {
  trackCustomEvent('Shop Flower Card Clicked');
};

export const shopAncillaryCardClickEvent = () => {
  trackCustomEvent('Shop Ancillary Card Clicked');
};

export const favoriteVendorClickEvent = ({ vendor }) => {
  trackCustomEvent('Favorite Vendor Clicked', {
    vendor_id: vendor.id,
    vendor_name: vendor.name,
  });
};

export const favoriteVendorsAllClickEvent = () => {
  trackCustomEvent('Favorite Vendors All Clicked');
};
